import { Link } from "react-router-dom";

const LINKS = [
  ["Terms", "/legal/terms"],
  ["Privacy", "/legal/privacy"],
  ["Merchant Agreement", "/legal/merchant"],
  ["Payments", "/legal/payments"],
  ["Refunds", "/legal/refunds"],
  ["Rewards", "/legal/rewards"],
  ["Electronic Comms", "/legal/e-comms"],
  ["Legal Center", "/legal"],
];

export const PortalFooter = () => (
  <footer className="border-t border-border px-4 py-6">
    <div className="mx-auto flex max-w-4xl flex-wrap items-center justify-center gap-x-4 gap-y-2">
      {LINKS.map(([label, to]) => (
        <Link key={to} to={to} data-testid={`portal-footer-${to.split("/").pop()}`}
          className="text-xs text-muted-foreground underline-offset-2 hover:text-foreground hover:underline">
          {label}
        </Link>
      ))}
    </div>
    <p className="mt-3 text-center text-[11px] text-muted-foreground">MONOE Pay LLC · monoepay.com</p>
  </footer>
);
